/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="63.15" height="83" viewBox="0 0 63.15 83" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g>
      <g>
        <path d="M107.86,35.79H68.42a1.23,1.23,0,0,0-.87.36L46.34,57a1.27,1.27,0,0,0-.38.89v59.61a1.25,1.25,0,0,0,1.25,1.25h60.65a1.25,1.25,0,0,0,1.25-1.25V37A1.25,1.25,0,0,0,107.86,35.79Zm-1.25,2.5v78H48.46V58.45L68.93,38.29Z" transform="translate(-45.96 -35.79)" fill="#0e497b"/>
        <path d="M68.24,35.8h.26l.12,0,.13,0,.12,0,.14.06.09.06.11.08.1.09.09.11,0,.06.07.1,0,.06,0,.12v0l0,.11,0,.13V37l.24,20.7A1.26,1.26,0,0,1,68.79,59h-.12l-21.45.19a1.25,1.25,0,0,1-1-2l.09-.09,21.22-20.9.09-.08.11-.08,0,0,.11-.06.12,0,.07,0ZM67.2,40,50.29,56.65l17.1-.15Z" transform="translate(-45.96 -35.79)" fill="#0e497b"/>
        <path d="M60.4,65.37a1.23,1.23,0,0,1,1.66-.05l.1.09,10.52,11A1.25,1.25,0,0,1,71,78.25l-.1-.1-10.51-11A1.25,1.25,0,0,1,60.4,65.37Z" transform="translate(-45.96 -35.79)" fill="#fcb61b"/>
        <path d="M71.22,65.67A1.25,1.25,0,0,1,73,67.39l-.09.1L61.81,77.9a1.24,1.24,0,0,1-1.76-.06,1.25,1.25,0,0,1,0-1.67l.09-.09Z" transform="translate(-45.96 -35.79)" fill="#fcb61b"/>
        <path d="M82.94,65.37a1.24,1.24,0,0,1,1.67-.05l.1.09,10.51,11a1.25,1.25,0,0,1,0,1.77,1.27,1.27,0,0,1-1.67,0l-.1-.1-10.51-11A1.25,1.25,0,0,1,82.94,65.37Z" transform="translate(-45.96 -35.79)" fill="#fcb61b"/>
        <path d="M93.76,65.67a1.25,1.25,0,0,1,1.81,1.72l-.1.1L84.36,77.9a1.25,1.25,0,0,1-1.81-1.73l.1-.09Z" transform="translate(-45.96 -35.79)" fill="#fcb61b"/>
        <path d="M67.14,94.6a24.84,24.84,0,0,1,25.25,2.34A1.25,1.25,0,0,1,91,99a22.4,22.4,0,0,0-22.84-2.12,22.68,22.68,0,0,0-2.8,1.46l-.33.2-.27.18-.29.2-.06,0a1.25,1.25,0,0,1-1.51-2l.2-.14.25-.18.33-.21.38-.24A26,26,0,0,1,67.14,94.6Z" transform="translate(-45.96 -35.79)" fill="#fcb61b"/>
      </g>
    </g>
</svg>

    );
  }
}

Icon.displayName = 'PaperWithDeadFaceIcon';

export default Icon;
